import React from "react";
import "./PromoBanner.css";

const promos = [
  "🔥 50% OFF on first order",
  "🚀 Free delivery above ₹299",
  "🎉 New restaurants added weekly",
  "⭐ Rate your order & win rewards",
];

const PromoBanner = () => {
  // Duplicate array to create seamless loop
  const seamlessPromos = [...promos, ...promos, ...promos, ...promos];

  return (
    <div className="promo-banner-section">
      <div className="promo-marquee-content">
        {seamlessPromos.map((promo, index) => (
          <span key={index} className="promo-item">
            {promo} &nbsp;&nbsp;·
          </span>
        ))}
      </div>
    </div>
  );
};

export default PromoBanner;
